const Ajax = window.util.ajax;
var openShow = false;
var tab = 1;
const __article = {
    showArticle() {
        $('._btn').hide();
        $('.content').css('height', 'auto');
    },
    btnStatus() {

        if ($('._contentText').height() > 275) {
            $('._btn').removeClass('hidden');
        }
    },
    addFriend() {
        Ajax({
            url: '/friend/ajaxAddFriend',
            type: "POST",
            data: {
                uid: $('._addFriend').attr('data-id')
            },
            callback(res) {

                if (res.code === 0) {
                    layer.msg('好友添加申请发送成功');

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    layer.msg(res.msg);
                }
            }
        });
    },
    deleteFriend() {
        layer.confirm('确认解除好友关系吗？', {
            btn: ['确认', '取消'],
            title: "提示"
        }, () => {
            Ajax({
                url: '/friend/ajaxSolveFriend',
                type: "POST",
                data: {
                    uid: $('._deleteFriend').attr('data-id')
                },
                callback(res) {

                    if (res.code === 0) {
                        layer.msg('解除好友关系成功');

                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    } else {
                        layer.msg(res.error[0].value);
                    }
                }
            });
        });
    },
    passFriend() {
        Ajax({
            url: '/friend/ajaxAgree',
            type: "POST",
            data: {
                uid: $('._passFriend').attr('data-id')
            },
            callback(res) {

                if (res.code === 0) {
                    layer.msg('好友申请已通过');

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    layer.msg(res.msg);
                }
            }
        });
    },
    ignoreFriend() {
        Ajax({
            url: '/friend/ajaxAddFriend',
            type: "POST",
            data: {
                uid: $('._ignore').attr('data-id')
            },
            callback(res) {
                if (res.code === 0) {
                    layer.msg('好友申请已忽略');

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    layer.msg(res.msg);
                }
            }
        });
    },
    noInterest() {
        let aid = $(this).attr('data-id'),
            content = {
                flag: false,
                rid: 0,
                type: 0,
                desc: '不感兴趣'
            };

        Ajax({
            url: '/article/addArtNegative',
            type: "POST",
            data: {
                aid: aid,
                content: JSON.stringify(content)
            },
            callback(res) {
                if (res.code === 0) {
                    layer.msg('将减少推荐类似内容');

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    layer.msg(res.msg);
                }
            }
        });
    },
    showNoInterest() {
        const $this = $(this);

        $this.addClass('_noInterestBtn').css({ width: '68px', background: '#e83632' });
        $this.find('span').show();
        $this.find('img').attr('src', '../vendors/images/meet/meet-nointerest.png');
    },
    hideNoInterest() {
        const $this = $(this);

        $this.removeClass('_noInterestBtn').css({ width: '25px', background: '#fff' });
        $this.find('span').hide();
        $this.find('img').attr('src', '../vendors/images/meet/meet-x.png');
    },
    showShadow() {
        $(this).addClass('list-item-hover');
    },
    hideShadow() {
        $(this).removeClass('list-item-hover');
    },
    setRecommendLabelHref() {
        const labelList = $('._recommendLabel');

        labelList.each((index, item) => {
            let href = "/search?keyword=" + encodeURIComponent($(item).attr('data-tag')) + "&classify=news";

            $(item).attr("href", href);
        });
    },
    // li列表超出部分隐藏起来
    hideOverFlowText() {
        const textList = $('#_hotNewsList li p');
        const maxSize = 37;

        textList.each((index, item) => {
            let text = $(item).text();

            if (text.length > maxSize) {
                $(item).text(text.slice(0, maxSize)+'...');
            }
        });
    },
    showDfkx() {
        if ($(".dfkx-popup").css("display") == 'none') {
            $(".dfkx-popup").show();
            $(".closeBox").css("transform", "rotate(90deg)");
        } else {
            $(".dfkx-popup").hide();
            $(".closeBox").css("transform", "rotate(0deg)");
        }

    },
    slideUpNewsList() {
        const textContent = $('#_hotNewsList');
        const textList = textContent.find('li');
        const length = textList.length;
        let idx = 0;

        setInterval(() => {
            const currHeight = textList.eq(idx).outerHeight();

            textContent.animate({
                'margin-top': '-'+currHeight
            }, () => {
                let t = textList.eq(idx).remove();

                if (idx >= length) {
                    idx = 0;
                } else {
                    idx++;
                }
                textContent.append(t);
                textContent.css('margin-top', 0);
            });
        }, 3000);
    },
    getQueryVariable(variable)     {
        var query = window.location.search.substring(1);
        var vars = query.split("&");

        for (var i=0; i<vars.length; i++) {
            var pair = vars[i].split("=");

            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    init() {
        openShow = __article.getQueryVariable('openShow');
        tab = __article.getQueryVariable('tab');
        if (openShow) {
            $(".closeBox").css("transform", "rotate(90deg)");
            $(".dfkx-popup").show();
            layui.use('element', function () {
                var element = layui.element;

                // 获取hash来切换选项卡，假设当前地址的hash为lay-id对应的值
                var layid = tab;

                element.tabChange('dfkxTab', layid); // 假设当前地址为：http://a.com#test1=222，那么选项卡会自动切换到“发送消息”这一项

                // 监听Tab切换，以改变地址hash值
                element.on('tab(dfkxTab)', function () {
                    location.hash = 'tab='+ this.getAttribute('lay-id');
                });
            });
        }
        __article.btnStatus();
        __article.hideOverFlowText();
        __article.slideUpNewsList();
        __article.setRecommendLabelHref();
    }
};

$(function () {

    __article.init();

    $(document)
        // 文章展示全文
        .on('click', '._showArticle', __article.showArticle)
        // // 加好友
        .on('click', '._addFriend', __article.addFriend)
        // // 解除好友
        // .on('click','._deleteFriend',__article.deleteFriend)
        // // 同意好友申请
        // .on('click','._passFriend',__article.passFriend)
        // // 拒绝好友申请
        // .on('click','._ignore',__article.ignoreFriend)
        // 划过后显示不感兴趣
        .on('mouseover', '._noInterest', __article.showNoInterest)
        // 划过后隐藏不感兴趣
        .on('mouseout', '._noInterest', __article.hideNoInterest)
        // 划过后阴影效果
        .on('mouseover', '.m-msg-list-item', __article.showShadow)
        // 划过后隐藏阴影效果
        .on('mouseout', '.m-msg-list-item', __article.hideShadow)
        // 不感兴趣点击
        .on('click', '._noInterestBtn', __article.noInterest)
        //
        .on('click', '#dfOpen', __article.showDfkx);
});